import React, { useState, useEffect, useRef } from "react";
import PageHeader from "../layout/PageHeader";
import SectionHeader from "../utilis/SectionHeader";
import ExchangeSection from "../element/homeComp/ExchangeSection";
import CompanySection from "../element/homeComp/CompanySection";
import AccountSection from "../element/homeComp/AccountSection";

const fromCurrencyOption = [
  { name: "United States", currencyCode: "USD" },
  { name: "United Kingdom", currencyCode: "GBP" },
  { name: "Canada", currencyCode: "CAD" },
  { name: "Australia", currencyCode: "AUD" },
  { name: "Germany", currencyCode: "EUR" },
  { name: "Japan", currencyCode: "JPY" },
  { name: "India", currencyCode: "INR" },
  { name: "Brazil", currencyCode: "BRL" },
  { name: "China", currencyCode: "CNY" },
  { name: "Pakistan", currencyCode: "PKR" },
];
const toCurrencyOption = [
  { name: "Pakistan", currencyCode: "PKR" },
  { name: "United Kingdom", currencyCode: "GBP" },
  { name: "Canada", currencyCode: "CAD" },
  { name: "Australia", currencyCode: "AUD" },
  { name: "Germany", currencyCode: "EUR" },
  { name: "Japan", currencyCode: "JPY" },
  { name: "India", currencyCode: "INR" },
  { name: "Brazil", currencyCode: "BRL" },
  { name: "China", currencyCode: "CNY" },
  { name: "United States", currencyCode: "USD" },
];


const Converter = () => {
  const [amount, setAmount] = useState(1);
  const [fromCurrency, setFromCurrency] = useState("USD");
  const [toCurrency, setToCurrency] = useState("PKR");
  const [rate, setCurrencyRate] = useState(0);
  const [convertedAmount, setConvertedAmount] = useState(0);
  const formCard = useRef()
  

  // STORING FROMCURRENCY OPTION VALUE
  const storeFromCurrency = (value) => {
    setFromCurrency(value);
    getData()
  };

  // STORING TOCURRENCY OPTION VALUE
  const storeToCurrency = (value) => {
    setToCurrency(value);
    getData()
  };

  // GETTING DATA AND PUTTING VALUES
  const getData = async () => {
    const result = document.querySelector(".result");
    result.textContent = "Fetching Data...";
   

    try {
      const data = await fetch(`https://v6.exchangerate-api.com/v6/f5631e1637605566e82b0da1/latest/${fromCurrency}`);
      const response = await data.json();
      const conversionRate = response.conversion_rates[toCurrency];
      setCurrencyRate(conversionRate);
      setConvertedAmount((amount * rate).toFixed(2));
      result.textContent = amount ?  `${amount} ${fromCurrency} = ${convertedAmount} ${toCurrency}` : `0 ${fromCurrency} = 0 ${toCurrency}` ;

    } catch (error) {
      console.log(error);
      formCard.innerHTML = `<h1 className='fw-800 text-black'>Error While Fetching Data</h1>`
    }
  };

  useEffect(() => {
    getData();
  });

  return (
    <>
      <div className="converter_page">
        <PageHeader title="Currency Converter" crumb="Currency" />
        <div className="container px-sm-2 px-4 section-padding">
          {/* HEADING SECTION START */}
          <div className="row padding-bottom">
            <div className="col-lg-6 col-sm-10 mx-auto" data-aos="zoom-in">
              <SectionHeader
                subTitle="CURRENCY CONVERTER"
                title="The Relaible, Cheap, & Fastest Way To Send Money Abroad"
              />
            </div>
          </div>

          {/* FORM SECTION */}
          <div className="row">
            <div className="col-lg-6 col-sm-10 mx-auto">
              <div ref={formCard} className="convertor_page_form p-4 bg-white shadow ">
                <h5 className="text-black fw-bold">Currency Converter</h5>
                <p className="text-black fw-light">I'd Like To Exchange</p>
                <input
                  type="number"
                  placeholder="$100"
                  className="form-control py-sm-4 py-3"
                  value={amount}
                  min={1}
                  onInput={(event) => setAmount(parseFloat(event.target.value))}
                />
                {/* COUNTRY FROM SECTION */}
                <p  className="text-black fw-600 my-3">
                  Country From
                </p>
                <select
                  className="form-select py-sm-4 py-3 fromCurrency"
                  onChange={(event) => storeFromCurrency(event.target.value)}
                >
                  {fromCurrencyOption.map((element, index) => {
                    return (
                      <option value={element.currencyCode} key={index}>
                        {`${element.currencyCode} (${element.name})`}
                      </option>
                    );
                  })}
                </select>
                {/* COUNTRY TO SECTION */}
                <p  className="text-black fw-600 my-3">
                  Country To
                </p>
                <select
                  className="form-select py-sm-4 py-3 toCurrency"
                  onChange={(event) => storeToCurrency(event.target.value)}
                >
                  {toCurrencyOption.map((element, index) => {
                    return (
                      <option value={element.currencyCode} key={index}>
                        {`${element.currencyCode} (${element.name})`}
                      </option>
                    );
                  })}
                </select>

                <h5 className=" text-center my-4 text-black fw-800 text-uppercase result"></h5>
                <button className="btn btn-primary mt-4 d-block w-100" >
                  Convert now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TOOL SECTION  */}
      <ExchangeSection />
      <CompanySection />
      <AccountSection />
    </>
  );
};

export default Converter;
